/*
 * ar-vorschlag.js — Vorschläge unter der Kopf-Suche (29.09.2026, Niclas: „wenn man was eingibt, dass
 * Vorschläge gemacht werden … Autocompletion-mäßig, dass Beispiele gezeigt werden“).
 *
 * Leer fokussiert: Stichwörter zum Ausprobieren (Einstellung search_try in ar-top) und die neuesten Cover.
 * Beim Tippen: passende Stichwörter und Cover aus dem Katalog, den ar.js ohnehin lädt (AR.catalog), mit der
 * Trefferregel der Wand (Titel, Tag oder Farbe enthält jedes Wort). Enter ohne Auswahl schickt das Formular
 * wie bisher in den Katalog (?q=). Eigene Datei, damit ein Fehler hier nie ar.js mitreißt.
 * Vertrag: form.ar-search[data-ar-suggest], Texte als data-l-*, Stichwörter als data-try.
 */
(function () {
  'use strict';
  var doc = document;
  var form = doc.querySelector('form.ar-search[data-ar-suggest]');
  if (!form) return;
  var input = form.querySelector('input[name="q"]');
  if (!input) return;

  var L = function (k, d) { return form.getAttribute('data-l-' + k) || d; };
  var T = {
    tryIt: L('try', 'Try'), covers: L('covers', 'Covers'), neu: L('new', 'Latest covers'), tags: L('tags', 'Tags'),
    alle: L('all', 'Show all results for'), keine: L('none', 'No covers for'), laden: L('loading', 'Loading covers…')
  };
  var SPUR = { instant: ['Instant download', '#b9e936'], named: ['Your name · 24 h', '#fc75b7'], one: ['1 of 1', '#34d1fd'] };
  /* Gleiche Synonyme wie ar.js (Ableitungen, SYN). */
  var SYN = { skull: ['skeleton'], skulls: ['skeleton'], skeletons: ['skeleton'], demon: ['devil'], demons: ['devil'] };
  var TRY = (form.getAttribute('data-try') || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
  var ZIEL = form.getAttribute('action') || '/collections/cover-artworks';

  var panel = doc.createElement('div');
  panel.className = 'ar-sug';
  panel.id = 'ar-sug';
  panel.hidden = true;
  panel.setAttribute('role', 'listbox');
  panel.setAttribute('aria-label', input.getAttribute('aria-label') || 'Search');
  form.appendChild(panel);
  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-controls', 'ar-sug');
  input.setAttribute('aria-expanded', 'false');

  var optionen = [], aktiv = -1, offen = false, wartet = false;

  function AR() { return window.AR || {}; }
  function katalog() { try { var a = AR(); return (a.catalog && a.catalog()) || []; } catch (e) { return []; } }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function url(q) { return ZIEL + (ZIEL.indexOf('?') >= 0 ? '&' : '?') + 'q=' + encodeURIComponent(q); }
  function bild(u, w) { if (!u) return ''; u = String(u).replace(/([?&])width=\d+/, '$1').replace(/[?&]+$/, '').replace(/\?&/, '?'); return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function hell(text, wort) {
    var t = String(text), i = wort ? t.toLowerCase().indexOf(wort) : -1;
    if (i < 0) return esc(t);
    return esc(t.slice(0, i)) + '<mark>' + esc(t.slice(i, i + wort.length)) + '</mark>' + esc(t.slice(i + wort.length));
  }
  function passt(r, worte) {
    return worte.every(function (q) {
      var qs = [q].concat(SYN[q] || []);
      return qs.some(function (w) {
        return r.t.toLowerCase().indexOf(w) >= 0 || (r.tags || []).concat(r.c || []).some(function (t) { return t.indexOf(w) >= 0; });
      });
    });
  }
  function tagZahlen(liste) { var z = {}; liste.forEach(function (r) { (r.tags || []).forEach(function (t) { z[t] = (z[t] || 0) + 1; }); }); return z; }
  function rang(r, q) {
    var t = r.t.toLowerCase();
    if (t.indexOf(q) === 0) return 0;
    if ((' ' + t).indexOf(' ' + q) >= 0) return 1;
    if (t.indexOf(q) >= 0) return 2;
    if ((r.tags || []).indexOf(q) >= 0) return 3;
    return 4;
  }

  function chip(text, href, zahl, wort) {
    return '<a class="ar-sug__chip" role="option" href="' + esc(href) + '"><span class="ar-sug__wort">' + hell(text, wort) + '</span>' + (zahl ? '<span class="ar-sug__zahl">' + zahl + '</span>' : '') + '</a>';
  }
  function cover(r, wort) {
    var s = SPUR[r.l] || SPUR.instant;
    return '<a class="ar-sug__cover" role="option" href="' + esc(r.url) + '">' +
      '<img src="' + esc(bild(r.img, 120)) + '" width="48" height="48" alt="" loading="lazy" decoding="async">' +
      '<span class="ar-sug__txt"><b>' + hell(r.t, wort) + '</b><i style="color:' + s[1] + '">' + esc(s[0]) + '</i></span>' +
      (r.money ? '<span class="ar-sug__preis">' + esc(r.money) + '</span>' : '') + '</a>';
  }
  function sek(kopf, inhalt, klasse) { return '<div class="ar-sug__sek"><p class="ar-sug__kopf">' + esc(kopf) + '</p><div class="' + klasse + '">' + inhalt + '</div></div>'; }

  function zeichne() {
    var q = input.value.trim().toLowerCase().replace(/\s+/g, ' ');
    var liste = katalog();
    var html = '';
    if (!liste.length) {
      html = '<p class="ar-sug__leer">' + esc(T.laden) + '</p>';
      if (!wartet) { wartet = true; var a = AR(); if (a.ready) a.ready(function () { wartet = false; if (offen) zeichne(); }); }
    } else {
      var kaufbar = liste.filter(function (r) { return r.a; });
      var zahlen = tagZahlen(liste);
      if (!q) {
        var tries = TRY.filter(function (t) { return zahlen[t]; });
        if (!tries.length) tries = Object.keys(zahlen).sort(function (a, b) { return zahlen[b] - zahlen[a]; }).slice(0, 8);
        html += sek(T.tryIt, tries.map(function (t) { return chip(t, url(t), 0, ''); }).join(''), 'ar-sug__chips');
        html += sek(T.neu, kaufbar.slice(0, 4).map(function (r) { return cover(r, ''); }).join(''), 'ar-sug__liste');
      } else {
        var worte = q.split(' ');
        var letzt = worte[worte.length - 1], davor = worte.slice(0, -1);
        var vorne = davor.length ? davor.join(' ') + ' ' : '';
        var tags = Object.keys(zahlen).filter(function (t) { return t.indexOf(letzt) === 0 && davor.indexOf(t) < 0; });
        if (tags.length < 3) tags = tags.concat(Object.keys(zahlen).filter(function (t) { return t.indexOf(letzt) > 0 && davor.indexOf(t) < 0; }));
        tags = tags.sort(function (a, b) { return zahlen[b] - zahlen[a]; }).slice(0, 6);
        var treffer = kaufbar.filter(function (r) { return passt(r, worte); });
        treffer.sort(function (a, b) { return rang(a, letzt) - rang(b, letzt) || a.idx - b.idx; });
        if (tags.length) html += sek(T.tags, tags.map(function (t) { return chip(t, url(vorne + t), zahlen[t], letzt); }).join(''), 'ar-sug__chips');
        if (treffer.length) {
          html += sek(T.covers, treffer.slice(0, 6).map(function (r) { return cover(r, letzt); }).join(''), 'ar-sug__liste');
          html += '<a class="ar-sug__alle" role="option" href="' + esc(url(q)) + '"><span>' + esc(T.alle) + ' “' + esc(q) + '”</span><b>' + treffer.length + ' &#8594;</b></a>';
        } else {
          var tries2 = TRY.filter(function (t) { return zahlen[t]; }).slice(0, 6);
          html += '<p class="ar-sug__leer">' + esc(T.keine) + ' “' + esc(q) + '”.</p>';
          if (!tags.length && tries2.length) html += sek(T.tryIt, tries2.map(function (t) { return chip(t, url(t), 0, ''); }).join(''), 'ar-sug__chips');
        }
      }
    }
    panel.innerHTML = html;
    optionen = Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
    optionen.forEach(function (o, i) { o.id = 'ar-sug-o' + i; o.setAttribute('aria-selected', 'false'); o.tabIndex = -1; });
    aktiv = -1;
    input.removeAttribute('aria-activedescendant');
  }

  function auf() {
    if (!offen) { offen = true; panel.hidden = false; input.setAttribute('aria-expanded', 'true'); form.classList.add('is-sug'); }
    zeichne();
  }
  function zu() {
    if (!offen) return;
    offen = false; panel.hidden = true; aktiv = -1;
    input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); form.classList.remove('is-sug');
  }
  function markiere(i) {
    if (!optionen.length) return;
    if (aktiv >= 0 && optionen[aktiv]) { optionen[aktiv].classList.remove('is-aktiv'); optionen[aktiv].setAttribute('aria-selected', 'false'); }
    aktiv = (i + optionen.length) % optionen.length;
    var o = optionen[aktiv];
    o.classList.add('is-aktiv'); o.setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', o.id);
    try { o.scrollIntoView({ block: 'nearest' }); } catch (e) {}
  }

  input.addEventListener('focus', auf);
  input.addEventListener('input', auf);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); if (!offen) auf(); markiere(aktiv + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); if (!offen) auf(); markiere(aktiv - 1); }
    else if (e.key === 'Enter' && offen && aktiv >= 0 && optionen[aktiv]) { e.preventDefault(); location.href = optionen[aktiv].href; }
    else if (e.key === 'Escape' && offen) { e.preventDefault(); zu(); }
  });
  /* Klick in die Liste nimmt dem Feld nicht den Fokus, sonst schließt das Blur die Liste vor dem Klick. */
  panel.addEventListener('mousedown', function (e) { e.preventDefault(); });
  input.addEventListener('blur', function () { setTimeout(function () { if (!form.contains(doc.activeElement)) zu(); }, 120); });
  /* Am Handy klappt die Suche beim Antippen auf: der Klick landet danach auf der Kopfleiste, nicht im Feld.
     Solange das Feld den Fokus hat, bleibt die Liste offen; das Schließen übernimmt dann das Blur. */
  doc.addEventListener('click', function (e) { if (offen && !form.contains(e.target) && doc.activeElement !== input) zu(); });
  /* Neuer Katalog (z. B. nach vollständigem Laden): offene Liste neu zeichnen. */
  doc.addEventListener('cr:katalog', function () { if (offen) zeichne(); });
  window.addEventListener('pageshow', function () { zu(); });
})();
